import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-exchange-detail',
  templateUrl: './exchange-detail.component.html',
  styleUrls: ['./exchange-detail.component.scss']
})
export class ExchangeDetailComponent implements OnInit {
  userData: any;
  games: string;
  liveUrl: SafeResourceUrl;
  match: any;
  token: string;
  operator_id: string;
  constructor(private router: Router, private http: HttpClient, public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem('userDetails'));
    this.view();
  }

  view() {
    let a = screen.width;
    this.match = JSON.parse(localStorage.getItem('selectedMatch'));
    this.token = localStorage.getItem('userAccessToken');
    this.operator_id = localStorage.getItem('operator')
    if(this.match.from_db == 1){
      if (this.operator_id != undefined || this.operator_id != null) {
        if (a <= 767) {
          this.games = "https://m2.fawk.app/#/splash-screen/" + this.token + "/" + this.operator_id + "?opentable=" + this.match.series_id;
          window.open(this.games, '_blank', 'location=yes,height=800,width=1200,scrollbars=yes,status=yes');
        } else {
          this.games = "https://d2.fawk.app/#/splash-screen/" + this.token + "/" + this.operator_id + "?opentable=" + this.match.series_id;
          window.open(this.games, '_blank', 'location=yes,height=800,width=1200,scrollbars=yes,status=yes');
        }
      } else {
        alert('Sorry For inconvenience . Please contact your Upper Level.')
      }
    } else {
      if (this.operator_id != undefined || this.operator_id != null) {
        if (a <= 767) {
          this.games = "https://m2.fawk.app/#/splash-screen/" + this.token + "/" + this.operator_id + "?opentable=" + this.match.match_id;
          window.open(this.games, '_blank', 'location=yes,height=800,width=1200,scrollbars=yes,status=yes');
        } else {
          this.games = "https://d2.fawk.app/#/splash-screen/" + this.token + "/" + this.operator_id + "?opentable=" + this.match.match_id;
           window.open(this.games, '_blank', 'location=yes,height=800,width=1200,scrollbars=yes,status=yes');
        }
      } else {
        alert('Sorry For inconvenience . Please contact your Upper Level.')
      }
    }
  }

}
